// extracted by mini-css-extract-plugin
export default {"formFooter":"AdminSSOUserCreationSettingCard-module__formFooter--8on0S","provisionsField":"AdminSSOUserCreationSettingCard-module__provisionsField--NBh-K"};